import type { SVGProps } from "react"
const Calendar = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19 11H5v7l.005.102A1 1 0 0 0 6 19h12a1 1 0 0 0 1-1v-7Zm0-4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v2h14V7Zm2 11a3 3 0 0 1-3 3H6a3 3 0 0 1-2.996-2.846L3 18V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 2 0v1h6V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11Z" />
  </svg>
)
export default Calendar
